<template>
  <v-card
    outlined
    rounded="md"
    class="product-card product-card-leaflet"
    :class="[promoClass]"
    :id="`product-card-${product.slug}`"
    @click="$emit('openDetail', product.productId)"
  >
    <div class="product pt-2">
      <div class="d-flex justify-end align-center w-100 top mr-2">
        <v-tooltip left :key="heartKey">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="px-0 product-icon-button"
              icon
              v-bind="attrs"
              v-on="on"
              @click.stop.prevent="addToList({ leaflet, product })"
              @mousedown.stop
              color="primary"
              aria-label="Aggiungi alla lista della spesa"
            >
              <v-icon>icon-lista</v-icon>
              <v-icon small class="mt-6 plus-iconn">$plus</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("product.addToList") }}</span>
        </v-tooltip>
      </div>
      <div class="w-100">
        <div class="d-flex flex-column body">
          <img
            :src="product.mediaURL"
            onerror="this.onerror=null;this.src='/no-icon.png'"
            class="product-img align-self-center"
            :alt="'Immagine' + product.name"
            :title="
              product.name + ' (' + product.codInt + '-' + product.codVar + ')'
            "
          />

          <div
            class="description default--text d-flex flex-column justify-left w-100 mt-3 ml-1 ml-sm-0"
          >
            <span class="name font-weight-bold">
              {{ product.name }}
            </span>
            <span class="cod-int text-caption d-none">
              cod. {{ product.codInt }}
            </span>
            <span class="short_descr">
              {{ product.shortDescr }}
            </span>
            <span class="descr">
              {{ product.description }}
              <span
                class="weight-unit"
                v-if="
                  product.productInfos &&
                    product.productInfos.TIPOLOGIA == 'Pezzo' &&
                    product.priceUmDisplay
                "
              >
                - {{ $n(product.priceUmDisplay, "currency") }}/{{
                  product.weightUnitDisplay
                }}
              </span>
            </span>
          </div>
        </div>
        <div class="actions leaflet-price" @click.stop.prevent>
          <!--  -->
          <ProductPrice v-if="product.priceDisplay" :product="product" />
        </div>
      </div>
    </div>
  </v-card>
</template>
<style lang="scss">
.product-card-leaflet {
  // .warehouse-promo-price .product_promo {
  //   flex-direction: column;
  // }
  .product-img {
    width: 170px;
    height: 170px;
    @media #{map-get($display-breakpoints, 'xs-only')} {
      margin: 0px 17px;
      width: 100px;
      height: 100px;
    }
  }
  .product .description .name {
    font-family: $heading-font-family;
  }
  .promo-wrapper {
    position: absolute;
    top: -1px;
    left: -1px;
    display: flex;
    flex-direction: column;
    z-index: 3;
  }
  .cart-item-info {
    margin-bottom: -21px;
  }
  .product-icon-button {
    position: relative;
  }
  .plus-iconn {
    height: 14px !important;
    width: 14px !important;
    padding: 2px;
    font-size: 14px;
    font-weight: bold;
    color: $white !important;
    border-radius: 50%;
    background-color: var(--v-primary-base);
    position: absolute;
    right: -1px;
    top: -11px;
  }
  .top {
    position: absolute;
    height: 26px;
  }
  @media #{map-get($display-breakpoints, 'xs-only')} {
    .product-price {
      width: 140px;
      text-align: center;
    }
  }
  .leaflet-price {
    .product-price {
      width: 100%;
      .promo_header {
        width: 50%;
      }
      .promo_body {
        width: 50%;
      }
    }
  }
}
</style>
<script>
import ProductPrice from "@/components/product/ProductPrice.vue";

import productMixin from "~/mixins/product";

import { mapState, mapGetters, mapActions } from "vuex";

import get from "lodash/get";
import cloneDeep from "lodash/cloneDeep";

export default {
  name: "ProductCard",
  props: {
    product: { type: Object, required: true },
    position: { type: Number, default: undefined },
    leaflet: { type: Object, required: true }
  },
  components: {
    ProductPrice
  },
  mixins: [productMixin],
  data() {
    return {
      selectOptionsArray: [],
      selectedOptions: {},
      key: 0
    };
  },
  computed: {
    ...mapGetters({
      getItem: "cart/getItem"
    }),
    ...mapState({
      cart: ({ cart }) => cart.cart
    }),
    promoProductClasses() {
      return this.product.productClasses.filter(
        pClass => pClass.productClassGroupId === 6
      );
    },
    item() {
      this.key;
      let item = this.getItem({
        product: this.product,
        ...this.selectedOptions
      });
      return item;
    },
    promoClass() {
      let productClasses = [];
      let cssClass = get(this.product, "warehousePromo.view.cssClass");
      if (cssClass) {
        productClasses.push("has-promo");
        productClasses.push(cssClass);
      }
      if (this.product.isNew) {
        productClasses.push("new-product");
      }
      if (this.product.badge) {
        productClasses.push(this.product.badge.cssClass);
      }
      return productClasses;
    }
  },
  methods: {
    ...mapActions({ addToList: "custom/addToLeafletList" }),
    giftAdded() {
      this.plus();
    },
    onOptionChanged(args) {
      let selectOption = args.selectOption;
      let option = args.option;
      this.key++;
      this.selectedOptions[selectOption.parameterName] = option.value;
    },
    async setSelectOptions() {
      await this.needLogin("selectoptionsmenu");
    },
    handleClick() {
      this.$emit("selectProduct");
    }
  },
  mounted() {
    if (this.product.selectOptions && this.product.selectOptions.length > 0) {
      this.selectOptionsArray = cloneDeep(this.product.selectOptions);
    }
  }
};
</script>
